window.MioFeaturedCarousel = window.MioFeaturedCarousel || {};

window.MioFeaturedCarousel.initSection = function initSection(sectionId) {
  const sectionRoot = document.getElementById(`shopify-section-${sectionId}`);

  if (!sectionRoot) return;

  const parsePrice = (text) => {
    if (!text) return NaN;

    const compact = text.replace(/\s+/g, '');
    const match = compact.match(/[-+]?\d[\d,.]*/);

    if (!match) return NaN;

    let value = match[0];

    if (value.includes(',') && value.includes('.')) {
      value = value.replace(/,/g, '');
    } else if (value.includes(',') && !value.includes('.')) {
      value = value.replace(',', '.');
    }

    return Number(value);
  };

  const updateSaleBadges = () => {
    const cards = sectionRoot.querySelectorAll('.product-card-wrapper');

    cards.forEach((card) => {
      const badgeWrap = card.querySelector('.card__badge');
      if (!badgeWrap) return;

      const badgeList = badgeWrap.querySelectorAll('.badge.mio-sale-badge');
      if (!badgeList.length) return;

      const primaryBadge = badgeWrap.querySelector('.badge.mio-sale-badge');
      if (!primaryBadge) return;

      const price = card.querySelector('.price.price--on-sale');
      const originalBadgeText = primaryBadge.textContent.trim();

      primaryBadge.classList.remove('mio-sale-badge');

      badgeList.forEach((badge, index) => {
        badge.style.display = index === 0 ? '' : 'none';
      });

      if (!price) return;

      const regularPriceEl =
        price.querySelector('.price__regular .price-item--regular') ||
        price.querySelector('.price-item--regular');

      const salePriceEl =
        price.querySelector('.price__sale .price-item--sale') ||
        price.querySelector('.price-item--sale');

      const regularPrice = parsePrice(regularPriceEl ? regularPriceEl.textContent : '');
      const salePrice = parsePrice(salePriceEl ? salePriceEl.textContent : '');

      if (!Number.isFinite(regularPrice) || !Number.isFinite(salePrice) || regularPrice <= salePrice) {
        primaryBadge.textContent = originalBadgeText || 'SALE';
        primaryBadge.classList.add('mio-sale-badge');
        primaryBadge.setAttribute(
          'aria-label',
          originalBadgeText ? originalBadgeText : 'Sale'
        );
        return;
      }

      const discountPercent = Math.max(
        1,
        Math.round(((regularPrice - salePrice) / regularPrice) * 100)
      );

      primaryBadge.textContent = `${discountPercent}% off`;
      primaryBadge.classList.add('mio-sale-badge');
      primaryBadge.setAttribute('aria-label', `Save ${discountPercent}%`);
    });
  };

  const runBadgeUpdate = () => {
    window.requestAnimationFrame(updateSaleBadges);
  };

  const getDailySeedDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const hashSeed = (seed) => {
    let hash = 2166136261;

    for (let index = 0; index < seed.length; index += 1) {
      hash ^= seed.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }

    return hash >>> 0;
  };

  const createSeededRandom = (seed) => {
    let state = hashSeed(seed) || 1;

    return () => {
      state += 0x6D2B79F5;
      let value = state;
      value = Math.imul(value ^ (value >>> 15), value | 1);
      value ^= value + Math.imul(value ^ (value >>> 7), value | 61);

      return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
    };
  };

  const setupFeaturedCarousel = () => {
    const viewport = sectionRoot.querySelector('[data-mio-featured-carousel]');
    const track = sectionRoot.querySelector('[data-mio-featured-carousel-track]');
    const sliderRoot = sectionRoot.querySelector('.mio-featured__slider');
    const shell = sectionRoot.querySelector('.mio-featured__carousel-shell');
    const controls = sectionRoot.querySelector('[data-mio-featured-controls]');
    const prevButton = sectionRoot.querySelector('[data-mio-featured-prev]');
    const nextButton = sectionRoot.querySelector('[data-mio-featured-next]');
    const autoplayToggleButton = sectionRoot.querySelector('[data-mio-featured-autoplay-toggle]');
    const autoplayToggleText = sectionRoot.querySelector('[data-mio-featured-autoplay-text]');
    const loadingStatus = sectionRoot.querySelector('[data-mio-featured-status]');

    if (
      !viewport ||
      !track ||
      !sliderRoot ||
      !shell ||
      !controls ||
      !prevButton ||
      !nextButton ||
      viewport.dataset.mioCarouselReady === 'true'
    ) {
      return;
    }

    let items = [...track.querySelectorAll('.grid__item:not([data-mio-carousel-clone])')];
    const dailyRandomOrderEnabled = viewport.dataset.mioFeaturedRandomOrder === 'true';
    const dailyRandomDate = getDailySeedDate();
    const dailyRandomSeed = `${dailyRandomDate}-${viewport.dataset.mioFeaturedRandomSeed || sectionId}`;
    let dailyRandomOrderFinalized = !dailyRandomOrderEnabled;
    let dailyRandomFinalizationPromise = null;

    const getDailyRandomProductKey = (item, index) => (
      item.dataset.mioFeaturedProductId ||
      item.id ||
      item.querySelector?.('.card__heading, .full-unstyled-link')?.textContent?.trim() ||
      `item-${index}`
    );

    const prepareDailyRandomItems = (sortableItems) => {
      sortableItems.forEach((item, index) => {
        if (!item.dataset.mioFeaturedRandomRank) {
          const productKey = getDailyRandomProductKey(item, index);
          item.dataset.mioFeaturedRandomKey = productKey;
          item.dataset.mioFeaturedRandomSourceIndex = String(index);
          item.dataset.mioFeaturedRandomRank = String(createSeededRandom(`${dailyRandomSeed}-${productKey}`)());
        }
      });

      return sortableItems.sort((firstItem, secondItem) => {
        const rankDifference =
          Number.parseFloat(firstItem.dataset.mioFeaturedRandomRank || '0') -
          Number.parseFloat(secondItem.dataset.mioFeaturedRandomRank || '0');

        if (rankDifference !== 0) return rankDifference;

        return (
          Number.parseInt(firstItem.dataset.mioFeaturedRandomSourceIndex || '0', 10) -
          Number.parseInt(secondItem.dataset.mioFeaturedRandomSourceIndex || '0', 10)
        );
      });
    };

    const applyDailyRandomOrder = (preserveScroll = false) => {
      if (!dailyRandomOrderEnabled) return items;

      const sortableItems = [...track.querySelectorAll('.grid__item:not([data-mio-carousel-clone])')];
      if (!sortableItems.length) return sortableItems;
      const scrollAnchor = preserveScroll
        ? sortableItems.find((item) => item.offsetLeft + item.offsetWidth > viewport.scrollLeft + 1)
        : null;
      const anchorOffset = scrollAnchor ? viewport.scrollLeft - scrollAnchor.offsetLeft : 0;
      const sortedItems = prepareDailyRandomItems(sortableItems);
      const fragment = document.createDocumentFragment();

      sortedItems.forEach((item, index) => {
        item.id = `Slide-${sectionId}-${index + 1}`;
        item.dataset.mioFeaturedRandomIndex = String(index + 1);
        fragment.appendChild(item);
      });

      track.appendChild(fragment);
      if (scrollAnchor?.isConnected) {
        viewport.scrollLeft = Math.max(0, scrollAnchor.offsetLeft + anchorOffset);
      }

      return sortedItems;
    };

    const materializeInitialDailyRandomSet = () => {
      const materializedCount = items.length;
      const connectedItems = new Set(items);
      const sortedItems = prepareDailyRandomItems([...items, ...bufferedFeedCards]);
      const materializedItems = sortedItems
        .slice(0, materializedCount)
        .map(materializeFeedCard);
      const deferredItems = sortedItems
        .slice(materializedCount)
        .map(serializeBufferedCard);
      const fragment = document.createDocumentFragment();

      items.forEach((item) => item.remove());
      bufferedFeedCards.length = 0;

      materializedItems.forEach((item, index) => {
        item.id = `Slide-${sectionId}-${index + 1}`;
        item.dataset.mioFeaturedRandomIndex = String(index + 1);
        fragment.appendChild(item);
      });

      track.appendChild(fragment);
      bufferedFeedCards.push(...deferredItems);
      items = materializedItems;

      materializedItems.forEach((item) => {
        prepareMaterializedFeedCard(item);
        upgradeClonedInteractiveElements(item);
        observeDeferredImages(item);
      });

      viewport.dataset.mioFeaturedLoadedCount = String(items.length);
      viewport.dataset.mioFeaturedReachableCount = String(items.length);
      viewport.dataset.mioFeaturedBufferedCount = String(bufferedFeedCards.length);
      viewport.dataset.mioFeaturedBufferFormat = bufferedFeedCards.length ? 'html' : 'empty';

      return materializedItems.filter((item) => !connectedItems.has(item)).length;
    };

    const revealDailyRandomOrder = (state = 'complete') => {
      if (!dailyRandomOrderEnabled || dailyRandomOrderFinalized) return;

      dailyRandomOrderFinalized = true;
      viewport.dataset.mioFeaturedRandomized = 'true';
      viewport.dataset.mioFeaturedRandomDate = dailyRandomDate;
      viewport.dataset.mioFeaturedRandomState = state;
      viewport.removeAttribute('aria-busy');
      sectionRoot.classList.remove('mio-featured-randomizing');
      sectionRoot.classList.add('mio-featured-randomized');
    };

    if (dailyRandomOrderEnabled) {
      viewport.setAttribute('aria-busy', 'true');
      viewport.dataset.mioFeaturedRandomized = 'false';
      viewport.dataset.mioFeaturedRandomState = 'pending';
    } else {
      viewport.dataset.mioFeaturedRandomized = 'false';
    }

    const loopingEnabled = false;
    const feedUrl = viewport.dataset.mioFeaturedFeedUrl || '';
    const feedSectionId = viewport.dataset.mioFeaturedFeedSectionId || '';
    const batchSize = Math.max(1, Number.parseInt(viewport.dataset.mioFeaturedBatchSize || '8', 10) || 8);
    let feedPage = 1;
    let feedHasMore = viewport.dataset.mioFeaturedHasMore === 'true' && Boolean(feedUrl && feedSectionId);
    let feedLoadingPromise = null;
    const bufferedFeedCards = [];
    let isSectionUnloaded = false;
    let firstFeedRequest = viewport.mioFeaturedFirstPage || null;
    if (firstFeedRequest) {
      const firstFeedUrl = new URL(feedUrl, window.location.origin);
      firstFeedUrl.searchParams.set('section_id', feedSectionId);
      firstFeedUrl.searchParams.set('page', '1');
      if (firstFeedRequest.url !== firstFeedUrl.toString() || firstFeedRequest.controller.signal.aborted) {
        firstFeedRequest.controller.abort();
        document.removeEventListener('shopify:section:unload', firstFeedRequest.onUnload);
        delete viewport.mioFeaturedFirstPage;
        firstFeedRequest = null;
      }
    }
    const feedAbortController = firstFeedRequest?.controller || new AbortController();
    const loadedProductIds = new Set(
      items.map((item) => item.dataset.mioFeaturedProductId).filter(Boolean)
    );
    viewport.dataset.mioFeaturedLoadedCount = String(items.length);
    viewport.dataset.mioFeaturedReachableCount = String(items.length);
    viewport.dataset.mioFeaturedFetchedCount = String(items.length);
    viewport.dataset.mioFeaturedBufferedCount = '0';
    viewport.dataset.mioFeaturedBufferFormat = 'empty';
    viewport.dataset.mioFeaturedFeedState = feedHasMore ? 'idle' : 'complete';
    const autoAdvanceEnabled = true;
    const initialAutoAdvanceDelay = 5200;
    const autoAdvanceDelay = 3900;
    const autoAdvanceSettleDelay = 520;
    const scrollTolerance = 4;
    const cardMemoryLimit = 32;
    const reducedMotionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    let prefersReducedMotion = reducedMotionQuery ? reducedMotionQuery.matches : false;
    let manualPause = false;
    let reducedMotionResumeOverride = false;

      if (!items.length) {
        revealDailyRandomOrder();
        controls.hidden = true;
        viewport.dataset.mioCarouselReady = 'true';
        viewport.dataset.mioCarouselState = 'empty';
      return;
    }

    items.forEach((item) => {
      item.classList.remove('scroll-trigger', 'animate--slide-in');
      item.classList.add('mio-featured__item--revealed');
      item.removeAttribute('data-cascade');
      item.style.removeProperty('--animation-order');
    });

    const stripIds = (element) => {
      if (element.removeAttribute) {
        element.removeAttribute('id');
      }

      element.querySelectorAll('[id]').forEach((child) => {
        child.removeAttribute('id');
      });
    };

    const prepareClone = (item) => {
      const clone = item.cloneNode(true);

      clone.dataset.mioCarouselClone = 'true';
      clone.classList.remove('scroll-trigger', 'animate--slide-in');
      clone.classList.add('mio-featured__item--revealed');
      clone.removeAttribute('data-cascade');
      clone.style.removeProperty('--animation-order');
      stripIds(clone);

      return clone;
    };

    const upgradeClonedInteractiveElements = (scope) => {
      if (!scope || !window.customElements || typeof window.customElements.upgrade !== 'function') return;

      scope.querySelectorAll('product-form, quick-add-modal').forEach((element) => {
        window.customElements.upgrade(element);
      });
    };

    const appendTrailingClones = () => {
      const trackStyles = window.getComputedStyle(track);
      const gap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap || '0') || 0;
      const cardWidth = items[0]?.getBoundingClientRect().width || viewport.clientWidth;
      const cardStep = Math.max(1, cardWidth + gap);
      const cloneBufferCount = Math.min(
        items.length,
        Math.max(2, Math.ceil(viewport.clientWidth / cardStep) + 1)
      );
      const fragment = document.createDocumentFragment();

      items.slice(0, cloneBufferCount).forEach((item) => {
        fragment.appendChild(prepareClone(item));
      });

      track.append(fragment);
      upgradeClonedInteractiveElements(track);
      viewport.dataset.mioCarouselCloneRepeats = 'buffer';
      viewport.dataset.mioCarouselCloneCount = String(cloneBufferCount);
    };

    viewport.dataset.mioCarouselCloneRepeats = 'none';
    viewport.dataset.mioCarouselCloneCount = '0';

    const hydrateDeferredImage = (image) => {
      if (!image || !image.dataset.mioCarouselSrc) return;

      if (image.dataset.mioCarouselSrcset) {
        image.srcset = image.dataset.mioCarouselSrcset;
      }

      image.src = image.dataset.mioCarouselSrc;
      image.removeAttribute('data-mio-carousel-src');
      image.removeAttribute('data-mio-carousel-srcset');
    };

    let deferredImageObserver = null;

    const observeDeferredImages = (scope = track) => {
      const deferredImages = scope.querySelectorAll('img[data-mio-carousel-src]');
      if (!deferredImages.length) return null;

      if (!('IntersectionObserver' in window)) {
        deferredImages.forEach(hydrateDeferredImage);
        return null;
      }

      if (!deferredImageObserver) {
        deferredImageObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              hydrateDeferredImage(entry.target);
              deferredImageObserver.unobserve(entry.target);
            });
          },
          {
            root: viewport,
            rootMargin: '0px 50%',
            threshold: 0
          }
        );
      }

      deferredImages.forEach((image) => deferredImageObserver.observe(image));
      return deferredImageObserver;
    };

    observeDeferredImages();

    const refreshItems = () => {
      items = [...track.querySelectorAll('.grid__item:not([data-mio-carousel-clone])')];
      viewport.dataset.mioCarouselItemCount = String(items.length);
      viewport.dataset.mioFeaturedLoadedCount = String(items.length);
      viewport.dataset.mioFeaturedReachableCount = String(items.length);
    };

    const announceLoadedProducts = (count) => {
      if (!loadingStatus || count < 1) return;

      loadingStatus.textContent = `${count} more featured products loaded.`;
    };

    const getVisibleCardCount = () => {
      const firstItem = items[0];
      const cardWidth = firstItem?.getBoundingClientRect().width || viewport.clientWidth;
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const step = Math.max(1, cardWidth + gap);

      return Math.max(1, Math.ceil(viewport.clientWidth / step));
    };

    const isNearLoadedEnd = () => {
      if (!items.length) return true;

      const firstItem = items[0];
      const cardWidth = firstItem?.getBoundingClientRect().width || viewport.clientWidth;
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const step = Math.max(1, cardWidth + gap);
      const currentIndex = Math.max(0, Math.round(viewport.scrollLeft / step));
      const remainingCards = items.length - currentIndex - getVisibleCardCount();

      return remainingCards <= Math.max(2, getVisibleCardCount());
    };

    const parseFeedResponse = (html) => {
      const metaTag = html.match(/<span\b[^>]*data-mio-featured-feed-meta[^>]*>/i)?.[0] || '';

      if (!metaTag) {
        throw new Error('Featured product feed response is missing required metadata.');
      }

      const cards = [];
      const cardPattern = /<!--m:(\d+)-->([\s\S]*?)<!--\/m-->/g;
      let cardMatch = null;

      while ((cardMatch = cardPattern.exec(html)) !== null) {
        cards.push({
          dataset: {
            mioFeaturedProductId: cardMatch[1]
          },
          html: cardMatch[2].trim()
        });
      }

      if (!cards.length && html.includes('data-mio-featured-feed-card')) {
        throw new Error('Featured product feed response is missing card boundaries.');
      }

      return {
        cards,
        hasNext: /data-has-next="true"/i.test(metaTag)
      };
    };

    const materializeFeedCard = (entry) => {
      if (entry instanceof Element) return entry;

      const template = document.createElement('template');
      template.innerHTML = entry.html;
      const card = template.content.firstElementChild;

      if (!card?.classList.contains('grid__item')) {
        throw new Error('Featured product card payload is invalid.');
      }

      Object.entries(entry.dataset).forEach(([key, value]) => {
        card.dataset[key] = value;
      });

      return card;
    };

    const serializeBufferedCard = (entry) => {
      if (!(entry instanceof Element)) return entry;

      return {
        dataset: { ...entry.dataset },
        html: entry.outerHTML
      };
    };

    const prepareMaterializedFeedCard = (card) => {
      card.classList.remove('scroll-trigger', 'animate--slide-in');
      card.classList.add('mio-featured__item--revealed');
      card.removeAttribute('data-mio-featured-feed-card');
      card.querySelectorAll('img, a[href]').forEach((element) => {
        element.setAttribute('draggable', 'false');
      });
    };

    const fetchFeedPage = async () => {
      const url = new URL(feedUrl, window.location.origin);
      url.searchParams.set('section_id', feedSectionId);
      url.searchParams.set('page', String(feedPage));

      let response;
      if (feedPage === 1 && firstFeedRequest && firstFeedRequest.url === url.toString()) {
        const prefetched = firstFeedRequest;
        firstFeedRequest = null;
        delete viewport.mioFeaturedFirstPage;
        document.removeEventListener('shopify:section:unload', prefetched.onUnload);
        const result = await prefetched.promise;
        if (result.error) throw result.error;
        response = result.response;
      } else {
        response = await window.fetch(url.toString(), {
          credentials: 'same-origin',
          signal: feedAbortController.signal,
          headers: {
            Accept: 'text/html'
          }
        });
      }

      if (!response.ok) {
        throw new Error(`Featured product feed request failed with ${response.status}.`);
      }

      const parsed = parseFeedResponse(await response.text());
      feedPage += 1;
      feedHasMore = parsed.hasNext;
      viewport.dataset.mioFeaturedHasMore = feedHasMore ? 'true' : 'false';

      parsed.cards.forEach((card) => {
        const productId = card.dataset.mioFeaturedProductId;

        if (!productId || loadedProductIds.has(productId)) return;

        loadedProductIds.add(productId);
        bufferedFeedCards.push(card);
      });

      viewport.dataset.mioFeaturedBufferedCount = String(bufferedFeedCards.length);
      viewport.dataset.mioFeaturedBufferFormat = bufferedFeedCards.length ? 'html' : 'empty';
      viewport.dataset.mioFeaturedFetchedCount = String(loadedProductIds.size);
    };

    const appendBufferedFeedCards = (appendCount = batchSize, options = {}) => {
      const preserveScroll = options.preserveScroll !== false;
      const announce = options.announce !== false;
      const sort = options.sort !== false;
      const refresh = options.refresh !== false;
      const cards = bufferedFeedCards.splice(0, appendCount).map(materializeFeedCard);
      if (!cards.length) return 0;

      const fragment = document.createDocumentFragment();

      cards.forEach((card, index) => {
        card.id = `Slide-${sectionId}-${items.length + index + 1}`;
        prepareMaterializedFeedCard(card);
        fragment.appendChild(card);
      });

      track.appendChild(fragment);
      if (refresh) {
        refreshItems();
      }
      if (sort) {
        items = applyDailyRandomOrder(preserveScroll);
      }
      viewport.dataset.mioFeaturedLoadedCount = String(items.length);
      viewport.dataset.mioFeaturedReachableCount = String(items.length);
      cards.forEach((card) => {
        upgradeClonedInteractiveElements(card);
        observeDeferredImages(card);
      });
      runBadgeUpdate();
      if (announce) {
        announceLoadedProducts(cards.length);
      }
      viewport.dataset.mioFeaturedFeedState = feedHasMore || bufferedFeedCards.length ? 'ready' : 'complete';
      viewport.dataset.mioFeaturedBufferedCount = String(bufferedFeedCards.length);
      viewport.dataset.mioFeaturedBufferFormat = bufferedFeedCards.length ? 'html' : 'empty';

      return cards.length;
    };

    const fetchNextFeaturedBatch = async (force = false, appendCount = batchSize) => {
      if (dailyRandomOrderEnabled && !dailyRandomOrderFinalized) return 0;
      if ((!force && !isNearLoadedEnd()) || (!feedHasMore && !bufferedFeedCards.length)) return 0;
      if (feedLoadingPromise) return feedLoadingPromise;

      viewport.dataset.mioFeaturedFeedState = 'loading';

      const loadPromise = (async () => {
        try {
          while (bufferedFeedCards.length < appendCount && feedHasMore) {
            await fetchFeedPage();
          }

          return appendBufferedFeedCards(appendCount);
        } catch (error) {
          if (isSectionUnloaded && error.name === 'AbortError') return 0;

          feedHasMore = false;
          viewport.dataset.mioFeaturedFeedState = 'error';
          console.warn('[Mio featured carousel] Unable to load more products.', error);
          return 0;
        }
      })();

      feedLoadingPromise = loadPromise;

      try {
        return await loadPromise;
      } finally {
        if (feedLoadingPromise === loadPromise) {
          feedLoadingPromise = null;
        }
      }
    };

    const finalizeDailyRandomOrder = async () => {
      if (isSectionUnloaded) return 0;
      if (!dailyRandomOrderEnabled) return 0;
      if (dailyRandomOrderFinalized) return items.length;
      if (dailyRandomFinalizationPromise) return dailyRandomFinalizationPromise;

      viewport.dataset.mioFeaturedRandomState = 'loading';
      viewport.dataset.mioFeaturedFeedState = feedHasMore ? 'loading' : 'ready';

      dailyRandomFinalizationPromise = (async () => {
        let appendedCount = 0;

        try {
          while (feedHasMore) {
            await fetchFeedPage();
          }
        } catch (error) {
          if (isSectionUnloaded && error.name === 'AbortError') return 0;

          feedHasMore = false;
          viewport.dataset.mioFeaturedFeedState = 'error';
          console.warn('[Mio featured carousel] Unable to complete daily random order feed.', error);
        } finally {
          if (!isSectionUnloaded) {
            appendedCount = materializeInitialDailyRandomSet();
            viewport.dataset.mioFeaturedFeedState =
              viewport.dataset.mioFeaturedFeedState === 'error'
                ? 'error'
                : bufferedFeedCards.length
                  ? 'ready'
                  : 'complete';
            viewport.dataset.mioFeaturedRandomLoadedCount = String(items.length);
            revealDailyRandomOrder(viewport.dataset.mioFeaturedFeedState === 'error' ? 'fallback' : 'complete');
            updateControls();
            scrollToTrueStart();
            runBadgeUpdate();
            window.requestAnimationFrame(clampScrollPosition);
            if (isInView) {
              startAutoAdvance(initialAutoAdvanceDelay);
            }
          }
          dailyRandomFinalizationPromise = null;
        }

        return appendedCount;
      })();

      return dailyRandomFinalizationPromise;
    };

    viewport.querySelectorAll('img, a[href]').forEach((element) => {
      element.setAttribute('draggable', 'false');
    });

    const getGap = () => {
      const styles = window.getComputedStyle(track);
      return Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
    };

    const getCardWidth = () => {
      const firstCard = items[0];
      return firstCard ? firstCard.getBoundingClientRect().width : viewport.clientWidth;
    };

    const getStep = () => {
      const cardWidth = getCardWidth();
      const gap = getGap();
      return (cardWidth + gap);
    };

    const getCycleDistance = () => {
      const firstClone = track.querySelector('[data-mio-carousel-clone="true"]');
      const firstItem = items[0];

      if (firstClone && firstItem) {
        const distance = firstClone.offsetLeft - firstItem.offsetLeft;

        if (distance > 0) return distance;
      }

      return (getCardWidth() + getGap()) * items.length;
    };

    const getMaxScroll = () => Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    const hasOverflow = () => items.length > 1 && getMaxScroll() > scrollTolerance;
    const isAtStart = () => viewport.scrollLeft <= scrollTolerance;
    const isAtEnd = () => viewport.scrollLeft >= getMaxScroll() - scrollTolerance;
    const past32Cards = [];
    const loopHistory = [];
    let memoryCursor = 0;

    const rememberCardsPassed = (count = 1) => {
      const safeCount = Math.max(0, Number.parseInt(count, 10) || 0);

      for (let index = 0; index < safeCount; index += 1) {
        past32Cards.push({
          cursor: memoryCursor,
          productIndex: items.length ? memoryCursor % items.length : 0
        });
        memoryCursor += 1;
      }

      if (past32Cards.length > cardMemoryLimit) {
        past32Cards.splice(0, past32Cards.length - cardMemoryLimit);
      }
    };

    const forgetCardsPassed = (count = 1) => {
      const safeCount = Math.max(0, Number.parseInt(count, 10) || 0);

      for (let index = 0; index < safeCount && past32Cards.length; index += 1) {
        past32Cards.pop();
      }
    };

    const canGoBackwardFromMemory = () => loopingEnabled && loopHistory.length > 0;

    const setButtonUnavailable = (button, unavailable) => {
      button.disabled = unavailable;
      button.classList.toggle('is-unavailable', unavailable);
      button.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      button.setAttribute('aria-hidden', unavailable ? 'true' : 'false');
      button.tabIndex = unavailable ? -1 : 0;
    };

    const updateControls = () => {
      const overflow = hasOverflow();
      const maxScroll = getMaxScroll();
      const atStart = isAtStart();
      const atEnd = isAtEnd();
      const canLoadMore = feedHasMore || bufferedFeedCards.length > 0 || Boolean(feedLoadingPromise);
      const atTrueStart = atStart;
      const atTrueEnd = atEnd && !canLoadMore;

      controls.hidden = !overflow && !canLoadMore;
      setButtonUnavailable(prevButton, !overflow || atTrueStart);
      setButtonUnavailable(nextButton, (!overflow && !canLoadMore) || atTrueEnd);
      if (autoplayToggleButton) {
        const autoplayUnavailable = (!overflow && !canLoadMore) || atTrueEnd;
        autoplayToggleButton.disabled = autoplayUnavailable;
        autoplayToggleButton.classList.toggle('is-unavailable', autoplayUnavailable);
      }

      viewport.dataset.mioCarouselState = !overflow
        ? 'no-overflow'
        : atStart
          ? 'start'
          : atTrueEnd
            ? 'end'
            : 'middle';
      viewport.dataset.mioCarouselScrollLeft = String(Math.round(viewport.scrollLeft));
      viewport.dataset.mioCarouselMaxScroll = String(Math.round(maxScroll));
      viewport.dataset.mioCarouselItemCount = String(items.length);
      viewport.dataset.mioCarouselCycleDistance = String(Math.round(getCycleDistance()));
      viewport.dataset.mioCarouselHistoryDepth = String(past32Cards.length);
      viewport.dataset.mioCarouselLoopDepth = String(loopHistory.length);
      updateAutoplayToggleState();
    };

    const setScrollLeftInstantly = (scrollLeft) => {
      const previousScrollBehavior = viewport.style.scrollBehavior;
      viewport.style.scrollBehavior = 'auto';
      viewport.scrollLeft = Math.max(0, Math.min(scrollLeft, getMaxScroll()));
      viewport.getBoundingClientRect();
      viewport.style.scrollBehavior = previousScrollBehavior;
    };

    const isMobileCarousel = () => window.matchMedia('(max-width: 749px)').matches;
    const premiumEase = (progress) => {
      if (progress <= 0) return 0;
      if (progress >= 1) return 1;

      return 1 - ((1 - progress) ** 2.35);
    };

    const getAnimatedScrollDuration = (delta) => {
      const step = Math.max(1, getStep());
      const stepCount = Math.max(1, Math.abs(delta) / step);

      if (isMobileCarousel()) {
        return Math.min(784, 476 + (Math.max(0, stepCount - 1) * 112));
      }

      return Math.min(560, 360 + (Math.max(0, stepCount - 1) * 70));
    };

    const scrollToLeftAnimated = (targetScrollLeft, onDone = null) => {
      const start = viewport.scrollLeft;
      const target = Math.max(0, Math.min(targetScrollLeft, getMaxScroll()));
      const delta = target - start;
      const duration = getAnimatedScrollDuration(delta);

      clearAnimatedSettle();
      animatedSettleDone = typeof onDone === 'function' ? onDone : null;

      if (Math.abs(delta) <= 1) {
        setScrollLeftInstantly(target);
        updateControls();
        if (animatedSettleDone) {
          const done = animatedSettleDone;
          animatedSettleDone = null;
          done(true);
        }
        return;
      }

      let frameId = null;
      const startedAt = performance.now();
      isAnimating = true;
      viewport.classList.add('is-animating');
      viewport.dataset.mioCarouselMotionState = 'animating';
      viewport.dataset.mioCarouselAnimationDuration = String(Math.round(duration));

      const tick = (now) => {
        const progress = Math.min(1, (now - startedAt) / duration);
        viewport.scrollLeft = start + (delta * premiumEase(progress));

        if (progress < 1) {
          frameId = window.requestAnimationFrame(tick);
          animatedSettleTimeout = frameId;
          return;
        }

        viewport.scrollLeft = target;
        viewport.dataset.mioCarouselMotionState = 'finalizing';
        frameId = window.requestAnimationFrame(() => {
          setScrollLeftInstantly(target);
          lastKnownScrollLeft = viewport.scrollLeft;
          updateControls();
          animatedSettleTimeout = null;
          isAnimating = false;
          viewport.classList.remove('is-animating');
          viewport.dataset.mioCarouselMotionState = 'idle';
          if (animatedSettleDone) {
            const done = animatedSettleDone;
            animatedSettleDone = null;
            done(true);
          }
        });
        animatedSettleTimeout = frameId;
      };

      frameId = window.requestAnimationFrame(tick);
      animatedSettleTimeout = frameId;
    };

    const scrollToTrueStart = () => {
      setScrollLeftInstantly(0);
      updateControls();
    };

    const clampScrollPosition = () => {
      const maxScroll = getMaxScroll();

      if (viewport.scrollLeft > maxScroll) {
        setScrollLeftInstantly(maxScroll);
      }

      if (Math.abs(viewport.scrollLeft) <= scrollTolerance) {
        setScrollLeftInstantly(0);
      }

      updateControls();
    };

    const scrollByStep = (direction, animate = true, onDone = null) => {
      const step = getStep();
      const maxScroll = getMaxScroll();
      const cycleDistance = getCycleDistance();
      let currentScrollLeft = viewport.scrollLeft;
      let rebased = false;
      let memoryAdjusted = false;

      if (loopingEnabled && direction > 0 && currentScrollLeft + step > maxScroll - scrollTolerance) {
        if (currentScrollLeft - cycleDistance >= 0) {
          currentScrollLeft -= cycleDistance;
        }

        setScrollLeftInstantly(currentScrollLeft);
        loopHistory.push(cycleDistance);
        rememberCardsPassed(items.length);
        rebased = true;
      }

      if (loopingEnabled && direction < 0 && currentScrollLeft - step < scrollTolerance && loopHistory.length) {
        const restoreDistance = loopHistory.pop() || cycleDistance;
        currentScrollLeft = Math.min(maxScroll, currentScrollLeft + restoreDistance);
        setScrollLeftInstantly(currentScrollLeft);
        forgetCardsPassed(items.length);
        rebased = true;
        memoryAdjusted = true;
      }

      const target = Math.max(
        0,
        Math.min(maxScroll, viewport.scrollLeft + (step * direction))
      );

      viewport.dataset.mioCarouselLastStep = String(Math.round(step));
      viewport.dataset.mioCarouselLastTarget = String(Math.round(target));

      if (rebased) {
        updateControls();
      }

      if (!memoryAdjusted && direction > 0) {
        rememberCardsPassed(1);
      } else if (!memoryAdjusted && direction < 0) {
        forgetCardsPassed(1);
      }

      if (animate) {
        suppressLoopRebaseUntil = performance.now() + 440;
        scrollToLeftAnimated(target, onDone);
      } else {
        setScrollLeftInstantly(target);
        updateControls();
        if (typeof onDone === 'function') onDone(true);
      }
    };

    const dragThreshold = 7;
    const suppressClickResetDelay = 420;
    let pointerId = null;
    let pointerStarted = false;
    let pointerType = '';
    let dragStartX = 0;
    let dragStartY = 0;
    let dragStartScrollLeft = 0;
    let dragLastDeltaX = 0;
    let dragSamples = [];
    let touchStarted = false;
    let touchIdentifier = null;
    let isDragging = false;
    let suppressClick = false;
    let suppressClickResetTimeout = null;
    let dragMoved = false;
    let dragScrollAnimationFrame = null;
    let pendingDragScrollLeft = null;
    let scrollAnimationFrame = null;
    let resizeAnimationFrame = null;
    let settleTimeout = null;
    let autoAdvanceTimeout = null;
    let autoAdvanceSettleTimeout = null;
    let interactionPauseTimeout = null;
    let interactionPausedUntil = 0;
    let isHovered = false;
    let hasFocusWithin = false;
    let isInView = true;
    let isAutoAdvancing = false;
    let isAnimating = false;
    let animatedSettleTimeout = null;
    let animatedSettleDone = null;
    let lastKnownScrollLeft = 0;
    let suppressLoopRebaseUntil = 0;
    let controlsHovered = false;
    let isProgrammaticStep = false;
    let isStepQueueRunning = false;
    let carouselObserver = null;
    let windowLoadHandler = null;
    const stepQueue = [];
    const maxQueuedSteps = 48;
    const useTouchGestureFallback = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    const carouselInitCount = Number.parseInt(viewport.dataset.mioCarouselInitCount || '0', 10) || 0;
    const debugEnabled = (() => {
      try {
        return new URLSearchParams(window.location.search).has('mioCarouselDebug');
      } catch (error) {
        return false;
      }
    })();
    let debugOverlay = null;
    let debugUpdateFrame = null;
    const debugState = {
      version: 'mio-carousel-debug-2026-05-18-a',
      roots: 0,
      slidesBeforeInit: items.length,
      slidesAfterInit: track.querySelectorAll('.grid__item').length,
      initCount: carouselInitCount + 1,
      pointerdown: 0,
      pointermove: 0,
      pointerup: 0,
      pointercancel: 0,
      dragstart: 0,
      touchstart: 0,
      touchmove: 0,
      touchend: 0,
      touchcancel: 0,
      clickAllowed: 0,
      clickSuppressed: 0,
      pointerType: '-',
      pointerId: '-',
      target: '-',
      targetKind: '-',
      dx: 0,
      dy: 0,
      ratio: '-',
      thresholdCrossed: false,
      horizontalIntent: false,
      verticalIntent: false,
      capture: '-',
      isDragging: false,
      suppressClick: false,
      viewportTouchAction: '-',
      slideTouchAction: '-',
      cardTouchAction: '-',
      targetTouchAction: '-',
      scrollLeft: 0,
      draggableLinks: 0,
      draggableImages: 0,
      touchFallback: useTouchGestureFallback,
      mode: 'idle',
      velocity: 0,
      currentIndex: 0,
      targetIndex: 0,
      snapEnabled: true,
      autoplayStatus: 'idle',
      autoplayResumeIn: 0,
      lastAction: '-',
      infiniteReset: '-'
    };

    viewport.dataset.mioCarouselInitCount = String(debugState.initCount);

    const describeDebugTarget = (target) => {
      if (!(target instanceof Element)) {
        return {
          target: String(target && target.nodeName ? target.nodeName : 'unknown'),
          targetKind: 'non-element'
        };
      }

      const className = typeof target.className === 'string'
        ? target.className.trim().replace(/\s+/g, '.')
        : '';
      const targetName = `${target.tagName.toLowerCase()}${className ? `.${className}` : ''}`;
      let targetKind = 'card';

      if (target.closest('.quick-add, product-form, quick-add-bulk')) {
        targetKind = 'quick-add';
      } else if (target.closest('button, input, select, textarea, label, [role="button"], [contenteditable="true"], modal-opener')) {
        targetKind = 'control';
      } else if (target.closest('summary')) {
        targetKind = 'summary';
      } else if (target.closest('a[href]')) {
        targetKind = 'link';
      } else if (target.closest('.mio-card-delivery-badge')) {
        targetKind = 'delivery-badge';
      } else if (target.closest('.mio-card-delivery-estimate')) {
        targetKind = 'delivery-estimate';
      } else if (target.closest('.price')) {
        targetKind = 'price';
      } else if (target.closest('.card__media')) {
        targetKind = 'media';
      }

      return { target: targetName.slice(0, 90), targetKind };
    };

    const readTouchAction = (element) => {
      if (!(element instanceof Element)) return '-';

      try {
        return window.getComputedStyle(element).touchAction || '-';
      } catch (error) {
        return '-';
      }
    };

    const updateDebugTouchActions = (target) => {
      if (!debugEnabled) return {};

      const slide = target instanceof Element ? target.closest('.grid__item') : null;
      const card = target instanceof Element ? target.closest('.product-card-wrapper') : null;

      return {
        viewportTouchAction: readTouchAction(viewport),
        slideTouchAction: readTouchAction(slide),
        cardTouchAction: readTouchAction(card),
        targetTouchAction: readTouchAction(target),
        roots: document.querySelectorAll('[data-mio-featured-carousel]').length,
        slidesAfterInit: track.querySelectorAll('.grid__item').length,
        scrollLeft: Math.round(viewport.scrollLeft),
        draggableLinks: viewport.querySelectorAll('a[draggable="false"]').length,
        draggableImages: viewport.querySelectorAll('img[draggable="false"]').length
      };
    };

    const renderDebugOverlay = () => {
      if (!debugEnabled) return;

      if (!debugOverlay) {
        debugOverlay = document.createElement('div');
        debugOverlay.setAttribute('aria-hidden', 'true');
        debugOverlay.style.cssText = [
          'position:fixed',
          'left:0',
          'right:0',
          'bottom:0',
          'z-index:2147483647',
          'max-height:42vh',
          'overflow:auto',
          'padding:8px 10px',
          'background:rgba(0,0,0,0.82)',
          'color:#fff',
          'font:11px/1.35 ui-monospace,SFMono-Regular,Menlo,Consolas,monospace',
          'white-space:pre-wrap',
          'pointer-events:none'
        ].join(';');
        document.body.appendChild(debugOverlay);
      }

      debugOverlay.textContent = [
        debugState.version,
        `roots=${debugState.roots} init=${debugState.initCount} slides=${debugState.slidesBeforeInit}/${debugState.slidesAfterInit}`,
        `pd=${debugState.pointerdown} pm=${debugState.pointermove} pu=${debugState.pointerup} pc=${debugState.pointercancel}`,
        `ts=${debugState.touchstart} tm=${debugState.touchmove} te=${debugState.touchend} tc=${debugState.touchcancel}`,
        `click allowed=${debugState.clickAllowed} suppressed=${debugState.clickSuppressed} dragstart=${debugState.dragstart}`,
        `type=${debugState.pointerType} id=${debugState.pointerId} target=${debugState.target}`,
        `kind=${debugState.targetKind} dx=${debugState.dx} dy=${debugState.dy} ratio=${debugState.ratio}`,
        `threshold=${debugState.thresholdCrossed} horizontal=${debugState.horizontalIntent} vertical=${debugState.verticalIntent}`,
        `mode=${debugState.mode} velocity=${debugState.velocity} index=${debugState.currentIndex}->${debugState.targetIndex}`,
        `capture=${debugState.capture} dragging=${debugState.isDragging} suppress=${debugState.suppressClick} snap=${debugState.snapEnabled}`,
        `autoplay=${debugState.autoplayStatus} resumeIn=${debugState.autoplayResumeIn}s last=${debugState.lastAction}`,
        `infiniteReset=${debugState.infiniteReset}`,
        `touchFallback=${debugState.touchFallback}`,
        `touchAction viewport=${debugState.viewportTouchAction} slide=${debugState.slideTouchAction} card=${debugState.cardTouchAction} target=${debugState.targetTouchAction}`,
        `scrollLeft=${debugState.scrollLeft} draggable links/img=${debugState.draggableLinks}/${debugState.draggableImages}`
      ].join('\n');
    };

    const debugLog = (label, patch = {}) => {
      if (!debugEnabled) return;

      Object.assign(debugState, patch);
      debugState.isDragging = isDragging;
      debugState.suppressClick = suppressClick;
      debugState.scrollLeft = Math.round(viewport.scrollLeft);

      if (!debugUpdateFrame) {
        debugUpdateFrame = window.requestAnimationFrame(() => {
          debugUpdateFrame = null;
          renderDebugOverlay();
        });
      }

      console.info('[Mio featured carousel debug]', label, { ...debugState });
    };

    const isInteractiveTarget = (target) => {
      if (!(target instanceof Element)) return false;

      return Boolean(
        target.closest(
          'button, input, select, textarea, label, summary, [role="button"], [contenteditable="true"], .quick-add, product-form, quick-add-bulk, modal-opener'
        )
      );
    };

    const isTouchDragExcludedTarget = (target) => {
      if (!(target instanceof Element)) return false;

      return Boolean(
        target.closest(
          'button, input, select, textarea, label, [role="button"], [contenteditable="true"], .quick-add, product-form, quick-add-bulk, modal-opener'
        )
      );
    };

    const getTrackedTouch = (touchList) => {
      if (touchIdentifier === null) return null;

      for (let index = 0; index < touchList.length; index += 1) {
        if (touchList[index].identifier === touchIdentifier) {
          return touchList[index];
        }
      }

      return null;
    };

    const resetDragSamples = (clientX) => {
      dragLastDeltaX = 0;
      dragSamples = [{
        x: clientX,
        time: performance.now()
      }];
    };

    const recordDragSample = (clientX, deltaX) => {
      const now = performance.now();

      dragLastDeltaX = deltaX;
      dragSamples.push({ x: clientX, time: now });

      while (dragSamples.length > 2 && now - dragSamples[0].time > 180) {
        dragSamples.shift();
      }
    };

    const getReleaseVelocity = () => {
      if (dragSamples.length < 2) return 0;

      const first = dragSamples[0];
      const last = dragSamples[dragSamples.length - 1];
      const elapsed = Math.max(1, last.time - first.time);

      return (last.x - first.x) / elapsed;
    };

    const cancelDragScrollFrame = () => {
      if (dragScrollAnimationFrame !== null) {
        window.cancelAnimationFrame(dragScrollAnimationFrame);
        dragScrollAnimationFrame = null;
      }

      pendingDragScrollLeft = null;
    };

    const flushDragScrollFrame = () => {
      if (dragScrollAnimationFrame !== null) {
        window.cancelAnimationFrame(dragScrollAnimationFrame);
        dragScrollAnimationFrame = null;
      }

      if (pendingDragScrollLeft === null) return;

      viewport.scrollLeft = pendingDragScrollLeft;
      pendingDragScrollLeft = null;
    };

    const scheduleDragScroll = (targetScrollLeft) => {
      pendingDragScrollLeft = targetScrollLeft;

      if (dragScrollAnimationFrame !== null) return;

      dragScrollAnimationFrame = window.requestAnimationFrame(() => {
        dragScrollAnimationFrame = null;

        if (pendingDragScrollLeft === null) return;

        viewport.scrollLeft = pendingDragScrollLeft;
        pendingDragScrollLeft = null;
      });
    };

    const getCurrentSlideIndex = () => {
      const step = getStep();

      if (!Number.isFinite(step) || step <= 0) return 0;

      return Math.round(viewport.scrollLeft / step);
    };

    const getProjectedSnapTarget = () => {
      const step = getStep();
      const maxScroll = getMaxScroll();

      if (!Number.isFinite(step) || step <= 0) return viewport.scrollLeft;

      const velocity = getReleaseVelocity();
      const currentIndex = Math.round(viewport.scrollLeft / step);
      const dragSlideDistance = Math.abs(dragLastDeltaX) / step;
      const releaseSpeed = Math.abs(velocity);
      const mobileCarousel = isMobileCarousel();
      const projectionMs = mobileCarousel ? 115 : 160;
      const projectedScrollLeft = viewport.scrollLeft - (velocity * projectionMs);
      const projectedIndex = Math.round(projectedScrollLeft / step);
      let maxExtraSlides = mobileCarousel ? 2 : 3;

      if (mobileCarousel) {
        if (dragSlideDistance < 1.75 && releaseSpeed < 1.35) {
          maxExtraSlides = 1;
        }
      } else if (dragSlideDistance < 1.65 && releaseSpeed < 1.25) {
        maxExtraSlides = 1;
      } else if (dragSlideDistance < 2.4 && releaseSpeed < 1.75) {
        maxExtraSlides = 2;
      }

      const limitedIndex = Math.max(
        currentIndex - maxExtraSlides,
        Math.min(currentIndex + maxExtraSlides, projectedIndex)
      );
      const target = Math.max(0, Math.min(maxScroll, limitedIndex * step));

      debugLog('project-snap-target', {
        velocity: velocity.toFixed(3),
        dragSlides: dragSlideDistance.toFixed(2),
        maxTravel: maxExtraSlides,
        currentIndex,
        targetIndex: limitedIndex,
        scrollLeft: Math.round(viewport.scrollLeft)
      });

      return target;
    };

    const normaliseLoopTarget = (targetScrollLeft, direction = 0) => {
      const maxScroll = getMaxScroll();
      if (!loopingEnabled) return Math.max(0, Math.min(maxScroll, targetScrollLeft));

      const cycleDistance = getCycleDistance();
      let target = Math.max(0, Math.min(maxScroll, targetScrollLeft));
      let current = viewport.scrollLeft;

      if (direction > 0 && target > maxScroll - scrollTolerance && current - cycleDistance >= 0) {
        current -= cycleDistance;
        target = Math.max(0, target - cycleDistance);
        setScrollLeftInstantly(current);
        loopHistory.push(cycleDistance);
        rememberCardsPassed(items.length);
        debugLog('infinite-reset-forward', {
          infiniteReset: 'forward-hidden',
          scrollLeft: Math.round(viewport.scrollLeft)
        });
      }

      if (direction < 0 && target < scrollTolerance && loopHistory.length) {
        const restoreDistance = loopHistory.pop() || cycleDistance;
        current = Math.min(maxScroll, current + restoreDistance);
        target = Math.min(maxScroll, target + restoreDistance);
        setScrollLeftInstantly(current);
        forgetCardsPassed(items.length);
        debugLog('infinite-reset-backward', {
          infiniteReset: 'backward-hidden',
          scrollLeft: Math.round(viewport.scrollLeft)
        });
      }

      return Math.max(0, Math.min(maxScroll, target));
    };

    const settleDragRelease = () => {
      if (!dragMoved) {
        queueSettledUpdate(120);
        return;
      }

      const rawTarget = getProjectedSnapTarget();
      const fallbackDirection = dragLastDeltaX < 0 ? 1 : dragLastDeltaX > 0 ? -1 : 0;
      const direction = Math.sign(rawTarget - viewport.scrollLeft) || fallbackDirection;
      const target = normaliseLoopTarget(rawTarget, direction);

      viewport.dataset.mioCarouselMotionState = 'settling';
      viewport.dataset.mioCarouselReleaseTarget = String(Math.round(target));
      suppressLoopRebaseUntil = performance.now() + getAnimatedScrollDuration(target - viewport.scrollLeft) + 120;

      scrollToLeftAnimated(target, () => {
        clampScrollPosition();
      });
    };

    const queueSettledUpdate = (delay = 120) => {
      window.clearTimeout(settleTimeout);
      settleTimeout = window.setTimeout(() => {
        clampScrollPosition();
      }, delay);
    };

    const rebaseForwardLoop = (allowDuringDrag = false) => {
      if (!loopingEnabled) return false;
      if (!hasOverflow()) return false;

      const cycleDistance = getCycleDistance();

      if (!Number.isFinite(cycleDistance) || cycleDistance <= 0) return false;

      const current = viewport.scrollLeft;
      const maxScroll = getMaxScroll();
      const step = getStep();
      const wrapThreshold = Math.max(step * 1.15, viewport.clientWidth * 0.5, scrollTolerance * 8);
      const nearEnd = current >= (maxScroll - wrapThreshold);

      if (!nearEnd || current - cycleDistance < 0) return false;

      setScrollLeftInstantly(current - cycleDistance);
      loopHistory.push(cycleDistance);
      rememberCardsPassed(items.length);

      if (allowDuringDrag && isDragging) {
        dragStartScrollLeft -= cycleDistance;
      }

      return true;
    };

    const rebaseBackwardLoop = (allowDuringDrag = false) => {
      if (!loopingEnabled) return false;
      if (!hasOverflow() || !loopHistory.length) return false;

      const cycleDistance = loopHistory[loopHistory.length - 1];

      if (!Number.isFinite(cycleDistance) || cycleDistance <= 0) return false;

      const current = viewport.scrollLeft;
      const step = getStep();
      const wrapThreshold = Math.max(step * 0.95, scrollTolerance * 8);
      const nearStart = current <= wrapThreshold;

      if (!nearStart) return false;

      loopHistory.pop();
      setScrollLeftInstantly(current + cycleDistance);
      forgetCardsPassed(items.length);

      if (allowDuringDrag && isDragging) {
        dragStartScrollLeft += cycleDistance;
      }

      return true;
    };

    const clearAnimatedSettle = () => {
      if (animatedSettleTimeout) {
        window.cancelAnimationFrame(animatedSettleTimeout);
        animatedSettleTimeout = null;
      }

      isAnimating = false;
      viewport.classList.remove('is-animating');
      viewport.dataset.mioCarouselMotionState = isDragging ? 'dragging' : 'idle';

      if (animatedSettleDone) {
        const done = animatedSettleDone;
        animatedSettleDone = null;
        done(false);
      }
    };

    const stopAutoAdvance = () => {
      if (autoAdvanceTimeout) {
        window.clearTimeout(autoAdvanceTimeout);
        autoAdvanceTimeout = null;
      }

      if (autoAdvanceSettleTimeout) {
        window.clearTimeout(autoAdvanceSettleTimeout);
        autoAdvanceSettleTimeout = null;
      }

      isAutoAdvancing = false;
      isProgrammaticStep = false;
    };

    const recordAction = (action) => {
      const currentCount = Number.parseInt(viewport.dataset.mioCarouselActionCount || '0', 10) || 0;

      viewport.dataset.mioCarouselLastAction = action;
      viewport.dataset.mioCarouselActionCount = String(currentCount + 1);
      debugLog('record-action', {
        lastAction: action
      });
    };

    const isAutoAdvancePausedByPreference = () => prefersReducedMotion && !reducedMotionResumeOverride;
    const isAutoAdvanceManuallyPaused = () => manualPause || isAutoAdvancePausedByPreference();
    const getInteractionPauseRemaining = () => Math.max(0, interactionPausedUntil - performance.now());
    const isInteractionPaused = () => getInteractionPauseRemaining() > 0;

    const clearInteractionPause = () => {
      interactionPausedUntil = 0;

      if (interactionPauseTimeout) {
        window.clearTimeout(interactionPauseTimeout);
        interactionPauseTimeout = null;
      }

      viewport.dataset.mioCarouselInteractionPaused = 'false';
      viewport.dataset.mioCarouselAutoplayResumeIn = '0';
    };

    const pauseAutoAdvanceAfterInteraction = (reason = 'interaction') => {
      const pauseDuration = 30000;

      interactionPausedUntil = performance.now() + pauseDuration;
      viewport.dataset.mioCarouselInteractionPaused = 'true';
      viewport.dataset.mioCarouselAutoplayResumeIn = '30';

      if (interactionPauseTimeout) {
        window.clearTimeout(interactionPauseTimeout);
      }

      stopAutoAdvance();
      interactionPauseTimeout = window.setTimeout(() => {
        interactionPauseTimeout = null;
        interactionPausedUntil = 0;
        viewport.dataset.mioCarouselInteractionPaused = 'false';
        viewport.dataset.mioCarouselAutoplayResumeIn = '0';
        startAutoAdvance(autoAdvanceDelay);
      }, pauseDuration);

      debugLog('interaction-pause', {
        autoplayStatus: 'interaction-paused',
        autoplayResumeIn: 30,
        lastAction: reason
      });
    };

    const updateAutoplayToggleState = () => {
      if (!autoplayToggleButton) return;

      const paused = isAutoAdvanceManuallyPaused();
      const controlLabel = paused ? 'Resume featured figures auto-scroll' : 'Pause featured figures auto-scroll';
      const controlText = paused ? 'Resume' : 'Pause';

      autoplayToggleButton.setAttribute('aria-label', controlLabel);
      autoplayToggleButton.setAttribute('aria-pressed', paused ? 'true' : 'false');
      autoplayToggleButton.dataset.mioAutoplayPaused = paused ? 'true' : 'false';
      autoplayToggleButton.classList.toggle('is-paused', paused);

      if (autoplayToggleText) autoplayToggleText.textContent = controlText;
    };

    const canAutoAdvance = () => (
      autoAdvanceEnabled &&
      (!dailyRandomOrderEnabled || dailyRandomOrderFinalized) &&
      hasOverflow() &&
      !document.hidden &&
      !isAutoAdvanceManuallyPaused() &&
      !isInteractionPaused() &&
      !isDragging &&
      !isAnimating &&
      !isProgrammaticStep &&
      !isStepQueueRunning &&
      !isHovered &&
      !controlsHovered &&
      !hasFocusWithin &&
      !(isAtEnd() && !feedHasMore && bufferedFeedCards.length === 0) &&
      isInView
    );

    const startAutoAdvance = (delay = autoAdvanceDelay) => {
      stopAutoAdvance();

      const interactionPauseRemaining = getInteractionPauseRemaining();

      if (interactionPauseRemaining > 0) {
        viewport.dataset.mioCarouselInteractionPaused = 'true';
        viewport.dataset.mioCarouselAutoplayResumeIn = String(Math.ceil(interactionPauseRemaining / 1000));
        autoAdvanceTimeout = window.setTimeout(() => {
          startAutoAdvance(delay);
        }, interactionPauseRemaining);
        debugLog('autoplay-interaction-paused', {
          autoplayStatus: 'interaction-paused',
          autoplayResumeIn: Math.ceil(interactionPauseRemaining / 1000)
        });
        return;
      }

      if (!canAutoAdvance()) return;

      autoAdvanceTimeout = window.setTimeout(async () => {
        if (!canAutoAdvance()) {
          startAutoAdvance(900);
          return;
        }

        await fetchNextFeaturedBatch(false);
        updateControls();
        if (nextButton.disabled) {
          stopAutoAdvance();
          return;
        }

        isAutoAdvancing = true;
        isProgrammaticStep = true;
        recordAction('auto-next');
        scrollByStep(1, true, () => {
          clampScrollPosition();
          isProgrammaticStep = false;
          isAutoAdvancing = false;
          startAutoAdvance();
        });

        autoAdvanceSettleTimeout = window.setTimeout(() => {
          if (isAutoAdvancing) {
            clampScrollPosition();
            isProgrammaticStep = false;
            isAutoAdvancing = false;
            startAutoAdvance();
          }
        }, autoAdvanceSettleDelay);
      }, delay);
    };

    const releaseDragPointer = () => {
      if (pointerId === null || !viewport.releasePointerCapture) return false;

      try {
        viewport.releasePointerCapture(pointerId);
        return true;
      } catch (error) {
        return false;
      }
    };

    const captureDragPointer = () => {
      if (pointerId === null || !viewport.setPointerCapture) return false;

      try {
        viewport.setPointerCapture(pointerId);
        return true;
      } catch (error) {
        return false;
      }
    };

    const setSuppressClickOnce = () => {
      suppressClick = true;
      window.clearTimeout(suppressClickResetTimeout);
      suppressClickResetTimeout = window.setTimeout(() => {
        suppressClick = false;
        suppressClickResetTimeout = null;
      }, suppressClickResetDelay);
    };

    const clearPointerState = (suppressNextClick = dragMoved) => {
      if (!pointerStarted && !isDragging) return;

      const shouldSuppressClick = Boolean(suppressNextClick || dragMoved);

      pointerStarted = false;
      isDragging = false;
      viewport.classList.remove('is-dragging');
      const releasedPointer = releaseDragPointer();

      pointerId = null;
      pointerType = '';

      if (shouldSuppressClick) {
        flushDragScrollFrame();
        setSuppressClickOnce();
        settleDragRelease();
        pauseAutoAdvanceAfterInteraction('drag');
      } else {
        cancelDragScrollFrame();
        dragMoved = false;
        queueSettledUpdate(160);
        startAutoAdvance(autoAdvanceDelay);
      }

      dragMoved = false;

      debugLog('clear-pointer-state', {
        capture: releasedPointer ? 'released' : debugState.capture,
        horizontalIntent: false,
        verticalIntent: false
      });
    };

    const clearTouchState = (suppressNextClick = dragMoved) => {
      if (!touchStarted && !isDragging) return;

      const shouldSuppressClick = Boolean(suppressNextClick || dragMoved);

      touchStarted = false;
      touchIdentifier = null;
      pointerStarted = false;
      isDragging = false;
      viewport.classList.remove('is-dragging');

      pointerId = null;
      pointerType = '';

      if (shouldSuppressClick) {
        flushDragScrollFrame();
        setSuppressClickOnce();
        settleDragRelease();
        pauseAutoAdvanceAfterInteraction('drag');
      } else {
        cancelDragScrollFrame();
        dragMoved = false;
        queueSettledUpdate(160);
        startAutoAdvance(autoAdvanceDelay);
      }

      dragMoved = false;

      debugLog('clear-touch-state', {
        capture: 'touch-fallback',
        horizontalIntent: false,
        verticalIntent: false
      });
    };

    const beginDrag = () => {
      if (isDragging) return;

      isDragging = true;
      dragMoved = true;
      viewport.classList.add('is-dragging');
      viewport.dataset.mioCarouselMotionState = 'dragging';
      const capturedPointer = touchStarted ? false : captureDragPointer();
      flushDragScrollFrame();
      setSuppressClickOnce();
      debugLog('begin-drag', {
        mode: 'dragging',
        snapEnabled: false,
        capture: touchStarted ? 'touch-fallback' : (capturedPointer ? 'yes' : debugState.capture),
        horizontalIntent: true,
        thresholdCrossed: true
      });
    };

    const processStepQueue = async () => {
      if (isStepQueueRunning) return;
      if (!stepQueue.length) return;

      isStepQueueRunning = true;
      stopAutoAdvance();

      while (stepQueue.length) {
        const direction = stepQueue.shift();

        if (direction < 0 && prevButton.disabled) continue;
        if (direction > 0 && nextButton.disabled) continue;
        if (direction > 0) {
          await fetchNextFeaturedBatch(false);
          updateControls();
          if (nextButton.disabled) continue;
        }

        isProgrammaticStep = true;
        clearAnimatedSettle();

        await new Promise((resolve) => {
          scrollByStep(direction, true, () => resolve(true));
        });

        isProgrammaticStep = false;
        queueSettledUpdate(80);
      }

      isStepQueueRunning = false;
      startAutoAdvance(autoAdvanceDelay);
    };

    const enqueueStep = (direction) => {
      if (direction < 0 && prevButton.disabled) return;
      if (direction > 0 && nextButton.disabled) return;

      if (stepQueue.length >= maxQueuedSteps) {
        stepQueue.shift();
      }

      stepQueue.push(direction);
      processStepQueue();
    };

    prevButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (prevButton.disabled) return;

      recordAction('previous-click');
      pauseAutoAdvanceAfterInteraction('previous-click');
      enqueueStep(-1);
    });

    nextButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (nextButton.disabled) return;

      recordAction('next-click');
      pauseAutoAdvanceAfterInteraction('next-click');
      enqueueStep(1);
    });

    shell.addEventListener('mouseenter', () => {
      isHovered = true;
      stopAutoAdvance();
    });

    shell.addEventListener('mouseleave', () => {
      isHovered = false;
      startAutoAdvance(autoAdvanceDelay);
    });

    controls.addEventListener('mouseenter', () => {
      controlsHovered = true;
      stopAutoAdvance();
    });

    controls.addEventListener('mouseleave', () => {
      controlsHovered = false;
      startAutoAdvance(autoAdvanceDelay);
    });

    sliderRoot.addEventListener('focusin', () => {
      hasFocusWithin = true;
      stopAutoAdvance();
    });

    sliderRoot.addEventListener('focusout', (event) => {
      if (!sliderRoot.contains(event.relatedTarget)) {
        hasFocusWithin = false;
        startAutoAdvance(autoAdvanceDelay);
      }
    });

    if (autoplayToggleButton) {
      autoplayToggleButton.addEventListener('click', () => {
        const currentlyPaused = isAutoAdvanceManuallyPaused();

        if (currentlyPaused) {
          manualPause = false;
          reducedMotionResumeOverride = true;
          clearInteractionPause();
          updateAutoplayToggleState();
          startAutoAdvance(200);
          return;
        }

        manualPause = true;
        clearInteractionPause();
        stopAutoAdvance();
        updateAutoplayToggleState();
      });
    }

    const handleReducedMotionChange = (event) => {
        prefersReducedMotion = event.matches;

        if (prefersReducedMotion) {
          reducedMotionResumeOverride = false;
          stopAutoAdvance();
        } else {
          startAutoAdvance(initialAutoAdvanceDelay);
        }

        updateAutoplayToggleState();
      };

    if (reducedMotionQuery) {
      if (typeof reducedMotionQuery.addEventListener === 'function') {
        reducedMotionQuery.addEventListener('change', handleReducedMotionChange);
      } else if (typeof reducedMotionQuery.addListener === 'function') {
        reducedMotionQuery.addListener(handleReducedMotionChange);
      }
    }

    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      const targetDetails = describeDebugTarget(event.target);

      if (event.pointerType === 'touch' && useTouchGestureFallback) {
        debugLog('pointerdown-touch-deferred', {
          ...targetDetails,
          ...updateDebugTouchActions(event.target),
          pointerdown: debugState.pointerdown + 1,
          pointerType: 'touch',
          pointerId: event.pointerId ?? '-',
          capture: 'touch-fallback'
        });
        return;
      }

      if (isInteractiveTarget(event.target)) {
        debugLog('pointerdown-ignored-interactive', {
          ...targetDetails,
          ...updateDebugTouchActions(event.target),
          pointerdown: debugState.pointerdown + 1,
          pointerType: event.pointerType || '-',
          pointerId: event.pointerId ?? '-',
          capture: 'ignored'
        });
        return;
      }

      pointerStarted = true;
      isDragging = false;
      suppressClick = false;
      dragMoved = false;
      pointerId = event.pointerId;
      pointerType = event.pointerType || '';
      dragStartX = event.clientX;
      dragStartY = event.clientY;
      dragStartScrollLeft = viewport.scrollLeft;
      resetDragSamples(event.clientX);
      stopAutoAdvance();
      clearAnimatedSettle();
      cancelDragScrollFrame();

      let capturedPointer = false;
      if (pointerType === 'touch' || pointerType === 'pen') {
        capturedPointer = captureDragPointer();
      }

      debugLog('pointerdown', {
        ...targetDetails,
        ...updateDebugTouchActions(event.target),
        pointerdown: debugState.pointerdown + 1,
        pointermove: 0,
        pointerup: 0,
        pointercancel: 0,
        pointerType: pointerType || '-',
        pointerId,
        dx: 0,
        dy: 0,
        ratio: '-',
        thresholdCrossed: false,
        horizontalIntent: false,
        verticalIntent: false,
        capture: capturedPointer ? 'yes' : (pointerType === 'touch' || pointerType === 'pen' ? 'failed' : 'not-set')
      });
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!pointerStarted || pointerId !== event.pointerId) return;

      const deltaX = event.clientX - dragStartX;
      const deltaY = event.clientY - dragStartY;
      const absoluteX = Math.abs(deltaX);
      const absoluteY = Math.abs(deltaY);
      const thresholdCrossed = absoluteX >= dragThreshold || absoluteY >= dragThreshold;
      const verticalIntent = pointerType === 'touch' && absoluteY > absoluteX;
      const horizontalIntent = thresholdCrossed && absoluteX > absoluteY;

      recordDragSample(event.clientX, deltaX);

      debugLog('pointermove', {
        pointermove: debugState.pointermove + 1,
        pointerType: pointerType || '-',
        pointerId,
        dx: Math.round(deltaX),
        dy: Math.round(deltaY),
        ratio: absoluteY ? (absoluteX / absoluteY).toFixed(2) : (absoluteX ? 'inf' : '-'),
        thresholdCrossed,
        horizontalIntent,
        verticalIntent,
        scrollLeft: Math.round(viewport.scrollLeft)
      });

      if (!isDragging) {
        if (absoluteX < dragThreshold && absoluteY < dragThreshold) return;

        if (pointerType === 'touch' && absoluteY > absoluteX) {
          debugLog('pointermove-vertical-intent', {
            verticalIntent: true,
            horizontalIntent: false
          });
          clearPointerState(false);
          return;
        }

        beginDrag();
      }

      if (event.cancelable) event.preventDefault();
      scheduleDragScroll(dragStartScrollLeft - deltaX);
      debugLog('pointermove-scroll', {
        scrollLeft: Math.round(pendingDragScrollLeft ?? viewport.scrollLeft)
      });
    });

    viewport.addEventListener('pointerup', (event) => {
      if (event.pointerType === 'touch' && useTouchGestureFallback) {
        debugLog('pointerup-touch-deferred', {
          pointerup: debugState.pointerup + 1,
          pointerType: 'touch',
          pointerId: event.pointerId ?? '-'
        });
        return;
      }

      debugLog('pointerup', {
        pointerup: debugState.pointerup + 1,
        pointerType: event.pointerType || pointerType || '-',
        pointerId: event.pointerId ?? pointerId ?? '-'
      });
      clearPointerState();
    });
    viewport.addEventListener('pointercancel', (event) => {
      if (event.pointerType === 'touch' && useTouchGestureFallback) {
        debugLog('pointercancel-touch-deferred', {
          pointercancel: debugState.pointercancel + 1,
          pointerType: 'touch',
          pointerId: event.pointerId ?? '-'
        });
        return;
      }

      debugLog('pointercancel', {
        pointercancel: debugState.pointercancel + 1,
        pointerType: event.pointerType || pointerType || '-',
        pointerId: event.pointerId ?? pointerId ?? '-'
      });
      clearPointerState();
    });
    viewport.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'mouse') {
        clearPointerState();
      }
    });

    if (useTouchGestureFallback) {
      viewport.addEventListener(
        'touchstart',
        (event) => {
          if (event.touches.length !== 1) {
            clearTouchState(false);
            return;
          }

          const targetDetails = describeDebugTarget(event.target);

          if (isTouchDragExcludedTarget(event.target)) {
            debugLog('touchstart-ignored-interactive', {
              ...targetDetails,
              ...updateDebugTouchActions(event.target),
              touchstart: debugState.touchstart + 1,
              pointerType: 'touch',
              pointerId: '-',
              capture: 'ignored'
            });
            return;
          }

          const touch = event.changedTouches[0];
          if (!touch) return;

          touchStarted = true;
          touchIdentifier = touch.identifier;
          pointerStarted = false;
          isDragging = false;
          suppressClick = false;
          dragMoved = false;
          pointerId = `touch:${touch.identifier}`;
          pointerType = 'touch';
          dragStartX = touch.clientX;
          dragStartY = touch.clientY;
          dragStartScrollLeft = viewport.scrollLeft;
          resetDragSamples(touch.clientX);
          stopAutoAdvance();
          clearAnimatedSettle();
          cancelDragScrollFrame();

          debugLog('touchstart', {
            ...targetDetails,
            ...updateDebugTouchActions(event.target),
            touchstart: debugState.touchstart + 1,
            touchmove: 0,
            touchend: 0,
            touchcancel: 0,
            pointerType: 'touch',
            pointerId,
            dx: 0,
            dy: 0,
            ratio: '-',
            thresholdCrossed: false,
            horizontalIntent: false,
            verticalIntent: false,
            capture: 'touch-fallback'
          });
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchmove',
        (event) => {
          if (!touchStarted) return;

          if (event.touches.length !== 1) {
            clearTouchState(false);
            return;
          }

          const touch = getTrackedTouch(event.touches);
          if (!touch) return;

          const deltaX = touch.clientX - dragStartX;
          const deltaY = touch.clientY - dragStartY;
          const absoluteX = Math.abs(deltaX);
          const absoluteY = Math.abs(deltaY);
          const thresholdCrossed = absoluteX >= dragThreshold || absoluteY >= dragThreshold;
          const verticalIntent = thresholdCrossed && absoluteY > absoluteX;
          const horizontalIntent = thresholdCrossed && absoluteX > absoluteY;

          recordDragSample(touch.clientX, deltaX);

          debugLog('touchmove', {
            touchmove: debugState.touchmove + 1,
            pointerType: 'touch',
            pointerId,
            dx: Math.round(deltaX),
            dy: Math.round(deltaY),
            ratio: absoluteY ? (absoluteX / absoluteY).toFixed(2) : (absoluteX ? 'inf' : '-'),
            thresholdCrossed,
            horizontalIntent,
            verticalIntent,
            scrollLeft: Math.round(viewport.scrollLeft)
          });

          if (!isDragging) {
            if (absoluteX < dragThreshold && absoluteY < dragThreshold) return;

            if (absoluteY > absoluteX) {
              debugLog('touchmove-vertical-intent', {
                verticalIntent: true,
                horizontalIntent: false
              });
              clearTouchState(false);
              return;
            }

            beginDrag();
          }

          if (event.cancelable) event.preventDefault();
          scheduleDragScroll(dragStartScrollLeft - deltaX);
          debugLog('touchmove-scroll', {
            scrollLeft: Math.round(pendingDragScrollLeft ?? viewport.scrollLeft)
          });
        },
        { passive: false }
      );

      viewport.addEventListener(
        'touchend',
        (event) => {
          if (!touchStarted) return;
          if (!getTrackedTouch(event.changedTouches)) return;

          debugLog('touchend', {
            touchend: debugState.touchend + 1,
            pointerType: 'touch',
            pointerId
          });
          clearTouchState();
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchcancel',
        (event) => {
          if (!touchStarted) return;
          if (!getTrackedTouch(event.changedTouches)) return;

          debugLog('touchcancel', {
            touchcancel: debugState.touchcancel + 1,
            pointerType: 'touch',
            pointerId
          });
          clearTouchState();
        },
        { passive: true }
      );
    }

    viewport.addEventListener(
      'dragstart',
      (event) => {
        const draggableTarget = event.target instanceof Element ? event.target.closest('a[href], img') : null;

        if (!draggableTarget) return;

        debugLog('dragstart-suppressed', {
          ...describeDebugTarget(event.target),
          dragstart: debugState.dragstart + 1
        });
        event.preventDefault();

        if (pointerStarted) {
          beginDrag();
        }
      },
      true
    );

    viewport.addEventListener(
      'click',
      (event) => {
        if (!suppressClick || event.detail === 0) {
          debugLog('click-allowed', {
            ...describeDebugTarget(event.target),
            clickAllowed: debugState.clickAllowed + 1,
            suppressClick: false
          });
          suppressClick = false;
          return;
        }

        debugLog('click-suppressed', {
          ...describeDebugTarget(event.target),
          clickSuppressed: debugState.clickSuppressed + 1,
          suppressClick: true
        });
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
        window.clearTimeout(suppressClickResetTimeout);
        suppressClickResetTimeout = null;
      },
      true
    );

    viewport.addEventListener(
      'wheel',
      () => {
        stopAutoAdvance();
        startAutoAdvance(autoAdvanceDelay);
      },
      { passive: true }
    );

    viewport.addEventListener(
      'scroll',
      () => {
        if (!isAnimating && scrollAnimationFrame === null) {
          scrollAnimationFrame = window.requestAnimationFrame(() => {
            scrollAnimationFrame = null;
            const current = viewport.scrollLeft;
            const movingForward = current > lastKnownScrollLeft + 1;
            const movingBackward = current + 1 < lastKnownScrollLeft;
            const canRebaseInScroll = isDragging || (!isProgrammaticStep && performance.now() >= suppressLoopRebaseUntil);

            if (canRebaseInScroll && movingForward) {
              rebaseForwardLoop(isDragging);
            }

            if (canRebaseInScroll && movingBackward) {
              rebaseBackwardLoop(isDragging);
            }

            lastKnownScrollLeft = viewport.scrollLeft;

            if (!isDragging) {
              updateControls();
            }

            if (movingForward) {
              fetchNextFeaturedBatch(false).then((loadedCount) => {
                if (loadedCount > 0) updateControls();
              });
            }
          });
        }

        if (!isDragging && !isAutoAdvancing && !isAnimating) {
          queueSettledUpdate();
        }
      },
      { passive: true }
    );

    const handleResize = () => {
      if (resizeAnimationFrame !== null) {
        window.cancelAnimationFrame(resizeAnimationFrame);
      }

      resizeAnimationFrame = window.requestAnimationFrame(() => {
        resizeAnimationFrame = null;
        clampScrollPosition();
        startAutoAdvance(initialAutoAdvanceDelay);
      });
    };

    window.addEventListener('resize', handleResize, { passive: true });

    const handleVisibilityChange = () => {
      if (document.hidden) {
        stopAutoAdvance();
        clearAnimatedSettle();
      } else {
        startAutoAdvance(initialAutoAdvanceDelay);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    if ('IntersectionObserver' in window) {
      carouselObserver = new window.IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          isInView = !!entry && entry.isIntersecting && entry.intersectionRatio > 0.2;

          if (isInView) {
            startAutoAdvance(initialAutoAdvanceDelay);
          } else {
            stopAutoAdvance();
            clearAnimatedSettle();
          }
        },
        {
          threshold: [0, 0.2, 0.45]
        }
      );

      carouselObserver.observe(shell);

    }

    if (dailyRandomOrderEnabled) {
      window.requestAnimationFrame(finalizeDailyRandomOrder);
    }

    scrollToTrueStart();
    viewport.dataset.mioCarouselMode = window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop';
    viewport.dataset.mioCarouselReady = 'true';
    debugLog('init', {
      ...updateDebugTouchActions(viewport),
      roots: document.querySelectorAll('[data-mio-featured-carousel]').length,
      slidesAfterInit: track.querySelectorAll('.grid__item').length
    });

    window.requestAnimationFrame(clampScrollPosition);

    if (document.readyState === 'complete') {
      startAutoAdvance(initialAutoAdvanceDelay);
    } else {
      windowLoadHandler = () => startAutoAdvance(initialAutoAdvanceDelay);
      window.addEventListener('load', windowLoadHandler, { once: true });
    }

    const handleSectionUnload = (event) => {
      if (!event.detail || String(event.detail.sectionId) !== String(sectionId)) return;

      isSectionUnloaded = true;
      if (firstFeedRequest) {
        document.removeEventListener('shopify:section:unload', firstFeedRequest.onUnload);
        delete viewport.mioFeaturedFirstPage;
        firstFeedRequest = null;
      }
      feedAbortController.abort();
      stopAutoAdvance();
      clearAnimatedSettle();
      cancelDragScrollFrame();
      releaseDragPointer();
      window.clearTimeout(settleTimeout);
      window.clearTimeout(suppressClickResetTimeout);

      if (debugUpdateFrame !== null) {
        window.cancelAnimationFrame(debugUpdateFrame);
        debugUpdateFrame = null;
      }

      if (debugOverlay) {
        debugOverlay.remove();
        debugOverlay = null;
      }

      if (scrollAnimationFrame !== null) {
        window.cancelAnimationFrame(scrollAnimationFrame);
        scrollAnimationFrame = null;
      }

      if (resizeAnimationFrame !== null) {
        window.cancelAnimationFrame(resizeAnimationFrame);
        resizeAnimationFrame = null;
      }

      if (carouselObserver) {
        carouselObserver.disconnect();
        carouselObserver = null;
      }

      if (deferredImageObserver) {
        deferredImageObserver.disconnect();
      }

      if (reducedMotionQuery) {
        if (typeof reducedMotionQuery.removeEventListener === 'function') {
          reducedMotionQuery.removeEventListener('change', handleReducedMotionChange);
        } else if (typeof reducedMotionQuery.removeListener === 'function') {
          reducedMotionQuery.removeListener(handleReducedMotionChange);
        }
      }

      if (windowLoadHandler) {
        window.removeEventListener('load', windowLoadHandler);
        windowLoadHandler = null;
      }

      window.removeEventListener('resize', handleResize);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      document.removeEventListener('shopify:section:unload', handleSectionUnload);
    };

    document.addEventListener('shopify:section:unload', handleSectionUnload);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        runBadgeUpdate();
        setupFeaturedCarousel();
      },
      { once: true }
    );
  } else {
    runBadgeUpdate();
    setupFeaturedCarousel();
  }

  window.MioFeaturedCarousel.sectionLoadHandlers = window.MioFeaturedCarousel.sectionLoadHandlers || {};

  if (!window.MioFeaturedCarousel.sectionLoadHandlers[sectionId]) {
    window.MioFeaturedCarousel.sectionLoadHandlers[sectionId] = (event) => {
      if (event.detail && String(event.detail.sectionId) === String(sectionId)) {
        window.MioFeaturedCarousel.initSection(sectionId);
      }
    };

    document.addEventListener('shopify:section:load', window.MioFeaturedCarousel.sectionLoadHandlers[sectionId]);
  }
};
